// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import {AXIOSAPI} from '@/api/api'
import {ENDPOINT} from '@/shared/constants'

class ApiRequests {
  static deactivateLicense (fingerprint) {
    var url = ENDPOINT + 'licenses/' + fingerprint + '/deactivate'
    return AXIOSAPI.post(url)
  }

  static getCustomers () {
    var params = {}
    var url = ENDPOINT + 'customers'
    params.sort = 'name'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static deleteFile (id) {
    var url = ENDPOINT + 'files/' + id
    return AXIOSAPI.delete(url)
  }

  static getFile (id) {
    var params = {}
    var url = ENDPOINT + 'files/' + id
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getFileMeta (id) {
    var params = {}
    var url = ENDPOINT + 'files/' + id + '/meta'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getRoles () {
    var params = {}
    var url = ENDPOINT + 'roles'
    params.sort = 'name'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getLicenses (active, inactive) {
    var params = {}
    var url = ENDPOINT + 'licenses'
    if (active) {
      params.active = 'true'
    } else if (inactive) {
      params.active = 'false'
    }
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getLicenseFlavors () {
    var params = {}
    var url = ENDPOINT + 'licenseflavors'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getLicenseItem (id) {
    var params = {}
    var url = ENDPOINT + 'items' + '/' + id
    return AXIOSAPI.get(url, { 'params': params })
  }

  static settingsPhotosGet () {
    var params = {}
    var url = ENDPOINT + 'config/photos/settings'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static settingsPhotosPut (value) {
    var params = {}
    var url = ENDPOINT + 'config/photos/settings'
    return AXIOSAPI.put(url, value, { 'params': params })
  }
}

export default ApiRequests



// WEBPACK FOOTER //
// ./src/api/ApiRequests.js